import { render, staticRenderFns } from "./loading-overlay.vue?vue&type=template&id=4bf03cc9&scoped=true&"
import script from "./loading-overlay.ts?vue&type=script&lang=ts&"
export * from "./loading-overlay.ts?vue&type=script&lang=ts&"
import style0 from "./loading-overlay.styl?vue&type=style&index=0&id=4bf03cc9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf03cc9",
  null
  
)

export default component.exports